import { connect } from 'react-redux'

import { organization } from '~publish/legacy/routes'
import type { RootState } from '~publish/legacy/store'

import MissingAccessPage from './components/MissingAccessPage'

export default connect(
  (state: RootState) => ({
    translations: state.i18n.translations['missing-access-page'],
  }),
  (_dispatch) => ({
    switchOrganization(orgId: string): void {
      window.location.assign(organization.getRoute({ orgId }))
    },
  }),
)(MissingAccessPage)
